import React from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'

import { GradientInfoHeader, WaveLinkHeader } from '@library/menu-page'

import type {
  MerchandisingHeaderContentBlock,
  WaveLinkHeaderContentBlock,
} from 'routes/Menu/MenuRecipesPage/CollectionHeader'
import { useWaveLinkHeaderClick } from 'routes/Menu/MenuRecipesPage/CollectionHeader/LinkHeaderContainer/useWaveLinkHeaderClick'
import { AccountOnHoldAlert } from 'routes/Menu/components/AccountOnHold/AccountOnHoldAlert'

import { FeaturedRangeCampaignBanner } from './FeaturedRangeCampaignBanner'

type FeaturedRangeCollectionHeaderProps = {
  showAccountOnHoldAlert: boolean
  merchandisingHeader?: MerchandisingHeaderContentBlock | null
}

const CustomBox = withCitrusTheme(Box, () => ({
  marginTop: '0',
  marginBottom: '0',
}))

const HeaderBox = withCitrusTheme(Box, (theme) => ({
  marginTop: '-3rem',
  paddingBottom: theme.spacing(12),
  [`@media (min-width: 544px)`]: {
    marginLeft: 12,
    marginRight: 12,
  },
  [`@media (min-width: 768px)`]: {
    marginLeft: -30,
    marginRight: -30,
  },
}))

const WaveLinkHeaderWrapper = ({ contentBlock }: { contentBlock: WaveLinkHeaderContentBlock }) => {
  const onWaveLinkHeaderClick = useWaveLinkHeaderClick(
    contentBlock.categoryId,
    contentBlock.categorySlug,
  )

  return <WaveLinkHeader contentBlock={contentBlock} onClick={onWaveLinkHeaderClick} />
}
export const FeaturedRangeCollectionHeader = ({
  showAccountOnHoldAlert,
  merchandisingHeader,
}: FeaturedRangeCollectionHeaderProps) => {
  if (showAccountOnHoldAlert) {
    return (
      <CustomBox>
        <AccountOnHoldAlert />
      </CustomBox>
    )
  }

  switch (merchandisingHeader?.type) {
    case 'wave-link-header':
      return (
        <HeaderBox data-testid="featured-range-header-box">
          <WaveLinkHeaderWrapper contentBlock={merchandisingHeader} />
        </HeaderBox>
      )
    case 'gradient-info-header':
      return (
        <HeaderBox data-testid="featured-range-header-box">
          <GradientInfoHeader contentBlock={merchandisingHeader} />
        </HeaderBox>
      )
    case 'campaign-banner':
    case 'compact-campaign-banner':
      return <FeaturedRangeCampaignBanner merchandisingHeader={merchandisingHeader} />
    default:
      return null
  }
}
